




import { Vue, Component } from 'vue-property-decorator';
// import Cats from './components/Cats.vue';
import Parallax from './components/Parallax.vue';

@Component({ components: { Parallax } })
export default class extends Vue {}
